<!-- <template>
	<div v-if="formShow">
		<formmain ref="formmain" :windowType="windowType" :width="width" :height="height" v-bind="$props"
			:loading="loading" @show="show" @hide="hide" @windowmodalLoad="windowmodalLoad">
			<template #title>
				<div>{{extra.title?extra.title:title}}</div>
			</template>
			<template #main>
				<div :ref="name+'_form'" style="margin-top: 30px;"></div>
			</template>
			<template #footer>
				<template v-if="controlltype==3">
					<vxe-button status="primary" content="启用编辑" @click="activeEdit"></vxe-button>
				</template>
				<template v-else>
					<vxe-button status="" content="取消" @click="hide"></vxe-button>
					<vxe-button status="primary" content="确定" @click="submit"></vxe-button>
				</template>
			</template>
		</formmain>
	</div>


</template> -->
<script>
	import formBase from '@_system/components/base/form.vue'
	export default {
		extends: formBase,
		name: 'supplierForm',
		props: {

		},
		data() {
			return {
				exportData: [],
				loading: false,
				company:[]
			}

		},
		render(h) {
			this.$slots.plug = [
				<vxe-table
					style="display:none"
          height="0"
          ref="supplierGoodsExportTable"
          data={this.exportData}>
          <vxe-column field="goodscode" title="商品编码" cell-type="string"></vxe-column>
          <vxe-column field="goodsname" title="商品名称" cell-type="string"></vxe-column>
			<vxe-column field="goodemodel" title="商品规格" cell-type="string"></vxe-column>
          <vxe-column field="boxgauge" title="盒规" cell-type="string"></vxe-column>
					<vxe-column field="bingauge" title="箱规" cell-type="string"></vxe-column>
					<vxe-column field="price1" title="当前价格" cell-type="string"></vxe-column>
					<vxe-column field="price2" title="盒规" cell-type="string"></vxe-column>
					<vxe-column field="boxgauge" title="盒规" cell-type="string"></vxe-column>
					<vxe-column field="price2" title="往期价格" cell-type="string"></vxe-column>
        </vxe-table>,
			]
			return formBase.render.call(this, h)
		},
		watch: {

		},

		computed: {

		},
		created() {

		},
		mounted() {

		},
		methods: {
			batchdelete_supplier_goods(){
				let $son_supplier_goods = this.fApi.el('$son_supplier_goods')
				let data =$son_supplier_goods.getGrid().getCheckboxRecords()
				if(!data.length){
					this.$message.error('请选择数据')
					return
				}
				data.forEach((item)=>{
					$son_supplier_goods.del(item)
				})
			},
			defaultconfig_supplier_parcel(){
				this.loading = true
				this.$api.supplier.getParcel({id:this.id}).then((res) => {
					let $son_supplier_parcel = this.fApi.el('$son_supplier_parcel')
					let fullData = $son_supplier_parcel.getTableData().fullData
					fullData.forEach((item)=>{
						$son_supplier_parcel.getGrid().remove(item)
					})
					res.forEach((config)=>{
						$son_supplier_parcel.getGrid().insertAt(config)
					})
					this.loading = false
					//console.log(fullData)
				},()=>{
					this.loading = false
				})
			},
			
			
			beforeInit(next) {
				this.$api.company.getemun().then((res) => {
					this.company = res
					next()
				})
			},
			beforeFormCreate(rule) {
				let options = this.company.map((item) => {
					return {
						label: item.name,
						value: item.name
					}
				})
				rule.forEach((item) => {
					if (item.field == 'selftitle') {
						item.options = options
					}
				})
			},
			paymentmethodChange(e){
				let fields = [
					'paymentlevel'
				]
				fields.forEach((item)=>{
					let rule =  this.fApi.getRule(item)
					if(e==8806){
						this.fApi.updateRule(item, {
							validate: [{
								message:rule.validate[0].message,
								pattern:rule.validate[0].pattern,
								required:true
							}]
						})
					}else{
						this.fApi.setValue('paymentlevel',null)
						this.fApi.updateRule(item, {
							validate: [{
								message:rule.validate[0].message,
								pattern:rule.validate[0].pattern,
								required:false
							}]
						})
					}
				})
				//console.log(rules)
			},		
			havetaxChange(e){
				let fields = [
					'taxpoint'
				]
				fields.forEach((item)=>{
					let rule =  this.fApi.getRule(item)
					if(e==5){
						this.fApi.setValue('invoicetype',331)
						this.fApi.updateRule(item, {
							validate: [{
								message:rule.validate[0].message,
								pattern:rule.validate[0].pattern,
								required:true
							}]
						})
					}else{
						this.fApi.setValue('invoicetype',null)
						this.fApi.setValue('taxpoint',0)
						this.fApi.updateRule(item, {
							validate: [{
								message:rule.validate[0].message,
								pattern:rule.validate[0].pattern,
								required:false
							}]
						})
					}
				})
				
			},
			uploadwlnChange(e){
				let fields = [
					'name',
					'type',
					'maingoodstype',
					'isnonstandard',
					//'phone',
					'havetax',
					'paymentmethod',
					'paymentlevel'
				]
				fields.forEach((item)=>{
					let rule =  this.fApi.getRule(item)
					if(e==5){
						let required = true
						//console.log(item,this.fApi.getValue(item))
						if(item == 'paymentlevel' && this.fApi.getValue('paymentmethod') == 8805){
							//console.log(this.fApi.getValue('paymentmethod'))
							required = false
						}
						//console.log(required)
						this.fApi.updateRule(item, {
							validate: [{
								message:rule.validate[0].message,
								pattern:rule.validate[0].pattern,
								required:required
							}]
						})
					}else{
						this.fApi.updateRule(item, {
							validate: [{
								message:rule.validate[0].message,
								pattern:rule.validate[0].pattern,
								required:false
							}]
						})
					}
				})
				//console.log(rules)
			},
			
			selftitleChange(e) {
				let company = this.company.find((item) => {
					return e == item.name
				})
				if(company){
					this.fApi.setValue('selftaxno', company.taxid)
				}else{
					this.fApi.setValue('selftaxno', null)
				}
		
			
			},
			beforeSubmit(formData, next) {
				// let phoneRegex = /^1[3-9]\d{9}$/;
				// if(!phoneRegex.test(formData.phone)){
				// 	this.$message.error('手机号格式错误')
				// 	return
				// }

				if(formData.havetax == 5 && !parseFloat(formData.taxpoint)){
					this.$message.error('是否含税为【是】税点不能为0')
					return
				}
				

				// if(this.fApi.getValue('havetax') == 5 && (!this.fApi.getValue('taxpoint') || this.fApi.getValue('taxpoint') == 0)){
				// 	this.$message.error('含专票【税点】必填')
				// 	return
				// }	
				
				let $son_supplier_account = this.fApi.el('$son_supplier_account')
				let fullData = $son_supplier_account.getTableData().fullData
				//console.log(fullData)
				fullData.forEach((item)=>{
					item.rcvAcc = item.rcvAcc?item.rcvAcc.replace(/\s+/g, ''):null
					item.rcvBankName = item.rcvBankName?item.rcvBankName.replace(/\s+/g, ''):null
					item.rcvName = item.rcvName?item.rcvName.replace(/\s+/g, ''):null
					if(item.accountbusiness==8920){
						item.payaccount = null
					}
				})
				
				let $son_supplier_goods = this.fApi.el('$son_supplier_goods')
				$son_supplier_goods.submit().then((res) => {
					if (res) {
						formData.$son_supplier_goods = res
							next()
					}
				})
			},
			regestEvent(rule, fApi) {
				let $son_supplier_goods = fApi.el('$son_supplier_goods')
				$son_supplier_goods.setRelationId({
					tabledataid: 'goodsid',
					boxdataid: 'id'
				})
				$son_supplier_goods.store.form = this
				let $son_supplier_goods_rule = fApi.getRule('$son_supplier_goods')
				fApi.updateRule('$son_supplier_goods', {
					on: {
						...$son_supplier_goods_rule.on,
						importtemplate: this.supplierGoodsImporttemplate,
						export: this.supplierGoodsExport,

					}
				})
				
			},
			supplierGoodsImporttemplate() {
				this.$store.commit('getTemplate', 'supplier_goods')
			},
			supplierGoodsExport() {

			},
			importtemplate(e) {

				console.log(e.moduleName)
			},
			export () {

			},

			importMethod(e) {
				let file = e.file
				let formData = new FormData()
				formData.append('excle', file)
				return new Promise((resolve) => {
					this.$api[this.name].goodsimport(this.id, formData).then((res) => {
						if (res.errorData.length != 0) {
							let message = ''
							res.errorData.forEach((item) => {
								message = message + item.goodscode + '：' + item.erro + '</br>'
							})
							this.$alert(message + '系统已忽略', res.errorData.length + '条数据错误', {
								dangerouslyUseHTMLString: true
							})
						}
						this.fApi.el('$son_supplier_goods').loadTableData()
						resolve()
					}, (e) => {
						this.$message.error(e)
						resolve()
					})
				})
			},
			exportMethod() {
				this.loading = true
				this.$api[this.name].goodsexport({
					supplierid: this.id
				}).then((res) => {
					//console.log(res)
					if (res.length != 0) {
						this.exportData = res

						this.$refs.supplierGoodsExportTable.exportData({
							filename: res[0]['suppliername'] + '_supplier_goods_export',
							type: 'xlsx',
							data: res,
						})
					} else {
						this.$message.error('暂无数据')
					}
					this.loading = false
				})
			}
		},
		components: {

		}
	}
</script>
